import { WarningIcon } from '@chakra-ui/icons'
import { Avatar, Box, Center, Flex, Icon, Input, Text, useToast } from '@chakra-ui/react'
import handleToast from '../HandleToast'

// kinda a fucked and ugly component but it works good trust
const FileUpload = ({
  isAvatar,
  src,
  setFile,
  accept,
  many = false,
  detail,
  label,
  fileLabel,
  maxFileSize = 15,
  isDisabled,
  isInvalid,
}: {
  maxFileSize?: number
  isAvatar?: boolean
  detail?: string
  label: string
  fileLabel?: string
  src?: string | null
  setFile: (f: File | FileList | null) => void
  accept?: string
  many?: boolean
  isDisabled?: boolean
  isInvalid?: boolean
}) => {
  const toast = useToast()

  const stripImageMetadata = (file: File): Promise<File> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = (event: any) => {
        const img = new Image()
        img.src = event.target.result
        img.onload = () => {
          const canvas = document.createElement('canvas')
          const ctx = canvas.getContext('2d')
          canvas.width = img.width
          canvas.height = img.height
          ctx?.drawImage(img, 0, 0)
          canvas.toBlob(
            (blob) => {
              if (blob) {
                const strippedFile = new File([blob], file.name, { type: blob.type })
                resolve(strippedFile)
              } else {
                reject(new Error('Image stripping failed'))
              }
            },
            'image/png',
            0.95
          )
        }
      }
      reader.onerror = reject
      reader.readAsDataURL(file)
    })
  }

  return (
    <>
      <Text textStyle="l-xs" color="solid.500" mb="4px">
        {label}
      </Text>
      <Box
        transition={'0.2s ease-out'}
        borderRadius="10px"
        position="relative"
        _hover={{
          boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
          border: 'solid.100',
          outline: 'solid.100',
        }}
      >
        <Box
          display={isAvatar ? 'flex' : 'block'}
          bgColor="neutral.10"
          opacity={isDisabled ? '0.5' : '1'}
          minH="75px"
          borderRadius="10px"
          border="1px dashed #DFE1E6"
          onDragOver={(e) => {
            e.preventDefault()
          }}
        >
          {isAvatar && <Avatar m="16px" src={src ?? ''} />}
          <Center padding="16px" display="flex" flexDir="column">
            <Text textStyle="b-sm" fontWeight="400" color="solid.900" mb="4px" mr={isAvatar ? 'auto' : ''}>
              Drop or{' '}
              <Text fontWeight="510" display="inline" textDecor="underline">
                click here
              </Text>{' '}
              to upload {fileLabel ?? 'an image'}
            </Text>
            <Text textStyle="b-xs" fontWeight="400" color="solid.500">
              {detail ?? 'PNG, JPG or WEBP. Image resolution 800x400px (max. 10 MB)'}
            </Text>
          </Center>
        </Box>
        <Input
          opacity="0"
          cursor={isDisabled ? 'not-allowed' : 'pointer'}
          type="file"
          accept={accept ?? undefined}
          minW="100%"
          h="80px"
          position="absolute"
          top="0"
          left="0"
          onChange={async (e) => {
            if (isDisabled) return
            const fileSize = maxFileSize * 1024 * 1024 // Convert maxFileSize from MB to bytes
            if (e.target.files) {
              const files = Array.from(e.target.files)
              const oversizedFiles = files.filter((file) => file.size > fileSize)

              if (oversizedFiles.length > 0) {
                handleToast(toast, false, 'Invalid files!', `File size exceeds ${maxFileSize}MB`)
                return
              }

              const strippedFiles = await Promise.all(
                files.map(async (file) => {
                  if (file.type.startsWith('image/')) {
                    return stripImageMetadata(file)
                  }
                  return file
                })
              )

              if (many) setFile(strippedFiles as unknown as FileList)
              else setFile(strippedFiles[0])
            } else return
          }}
          value={''}
          multiple={many}
        />
      </Box>
      {isInvalid && (
        <Flex w="100%" mt={1} alignItems="center" gap="4px">
          <Icon w="16px" h="16px" viewBox="0 0 24 24" fill="none" color="error.100" mt="2px">
            <WarningIcon />
          </Icon>
          <Text textStyle="b-xs" color="error.100">
            Please select valid file!
          </Text>
        </Flex>
      )}
    </>
  )
}

export default FileUpload
